export default {
  data() {
    return {
      pagination: {
        page: 1,
        pageSize: 20,
        total: 0,
      },
      selectedRows: [],
      pageSizes: [10, 20, 50, 100],
      headerStyle: {
        background: '#fafafa',
      },
      tableNoDataImg: require('@/assets/nodata_images/table-no-data.png'),
    }
  },
  computed: {
    tableHeight() {
      return this.$baseTableHeight(-70)
    },
  },
  methods: {
    selectionChange(selection) {
      this.selectedRows = selection
    },
    handleSizeChange(size) {
      this.pagination.pageSize = size
      this.search()
    },
    handleCurrentChange(currentPage) {
      this.pagination.page = currentPage
      this.search('pageChange')
    },
  },
}
